import { SearchState } from 'src/hooks/meilisearch/types/search-state';

export const employeesKeys = {
  all: ['employees'] as const,
  lists: () => [...employeesKeys.all, 'list'] as const,
  list: (
    directoryToken: string,
    page: number,
    perPage: number,
    searchState?: SearchState,
  ) =>
    [
      ...employeesKeys.lists(),
      directoryToken,
      { page, perPage, ...searchState },
    ] as const,
  details: () => [...employeesKeys.all, 'detail'] as const,
  detail: (
    groupToken: string,
    directoryToken: string,
    page: number,
    perPage: number,
    searchState?: SearchState,
  ) =>
    [
      ...employeesKeys.details(),
      groupToken,
      directoryToken,
      { page, perPage, ...searchState },
    ] as const,
};
